import {Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';

import {Channel} from 'domain/usecases/private/service-points/get-service-points';
import {useServicePointAddress} from './hooks/useServicePointAddress';
import {StyledButton} from './styles';

const {seeMap} = translations['pt-br'].commons;

export function ServicePointAddress({servicePoint}: {servicePoint: Channel}) {
	const {handleOpenGoogleMaps, address, palette} = useServicePointAddress(servicePoint);

	return (
		<Stack direction="row" gap={1} alignItems={'flex-start'}>
			<Stack flexShrink={0}>
				<Icon name="location-default" size={24} color={palette.primary.main} />
			</Stack>
			<Stack gap={1} alignItems="flex-start">
				<Typography color="text.secondary" variant="body1">
					{address}
				</Typography>
				<StyledButton
					variant="text"
					size="small"
					startIcon={<Icon name="ben-export" size={16} color={palette.primary.main} />}
					onClick={handleOpenGoogleMaps}>
					{seeMap}
				</StyledButton>
			</Stack>
		</Stack>
	);
}
